<div class="whyKetto">
  <div class="content" *ngFor="let item of whyKetto">
    <img [src]="item.imgpath" alt="">
    <div class="sub">{{item?.sub}}</div>
  </div>
</div>